import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Colors } from "../constants/Colors";
import PrivacyPolicyModal from "./PrivacyPolicyModal";
import TermsOfServiceModal from "./TermsOfServiceModal";
import logo from "../assets/images/ArkilaLogo.png";
import "../styles/adminFooter.css";

/**
 * Footer links mirror the sidebar navigation exactly —
 * every route here exists in Sidebar.jsx, nothing else.
 */
const FOOTER_COLUMNS = [
  {
    heading: "Operations",
    links: [
      { to: "/dashboard", label: "Dashboard" },
      { to: "/bookings", label: "Bookings" },
      { to: "/passengers", label: "Passengers" },
      { to: "/location", label: "Location & Tracking" },
    ],
  },
  {
    heading: "Operators",
    links: [
      { to: "/operators/operators", label: "All Operators" },
      { to: "/operators/jeepney", label: "Jeepney Management" },
      { to: "/operators/drivers", label: "Driver Management" },
    ],
  },
  {
    heading: "Payments",
    links: [
      { to: "/payments/payouts", label: "Payout" },
      { to: "/payments-commission", label: "Commissions" },
      { to: "/payments-history", label: "Payment History" },
    ],
  },
  {
    heading: "Insights",
    links: [
      { to: "/ratings", label: "Rating & Feedback" },
      { to: "/audit/audit-logs", label: "Audit Logs" },
      { to: "/settings/settings", label: "Settings" },
    ],
  },
];

const AdminFooter = () => {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  return (
    <>
      <footer
        className="admin-footer"
        style={{
          "--footer-bg": Colors.CARD_BACKGROUND,
          "--footer-border": Colors.BORDER_GRAY,
          "--footer-text-dark": Colors.TEXT_DARK,
          "--footer-text-light": Colors.TEXT_LIGHT,
          "--footer-accent": Colors.PRIMARY,
          "--footer-blue": Colors.SECONDARY_BLUE,
          "--footer-cyan": Colors.LIGHT_BLUE,
        }}
      >
        <div className="admin-footer-inner">
          <div className="admin-footer-grid">
            {/* Brand */}
            <div className="admin-footer-brand">
              <img src={logo} alt="Arkila" className="admin-footer-logo" />
              <p className="admin-footer-tagline">
                Manage jeepney rentals, bookings, operators and payments from
                one place.
              </p>
            </div>

            {FOOTER_COLUMNS.map((col) => (
              <FooterColumn
                key={col.heading}
                heading={col.heading}
                links={col.links}
              />
            ))}
          </div>

          {/* Bottom bar */}
          <div className="admin-footer-bottom">
            <p className="admin-footer-copyright">
              © {new Date().getFullYear()} Arkila Admin Panel. All rights
              reserved.
            </p>

            <div className="admin-footer-legal">
              <button
                type="button"
                className="admin-footer-legal-btn"
                onClick={() => setShowPrivacyModal(true)}
              >
                Privacy Policy
              </button>
              <span className="admin-footer-sep" aria-hidden="true" />
              <button
                type="button"
                className="admin-footer-legal-btn"
                onClick={() => setShowTermsModal(true)}
              >
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </footer>

      <PrivacyPolicyModal
        isOpen={showPrivacyModal}
        onClose={() => setShowPrivacyModal(false)}
      />
      <TermsOfServiceModal
        isOpen={showTermsModal}
        onClose={() => setShowTermsModal(false)}
      />
    </>
  );
};

const FooterColumn = ({ heading, links }) => (
  <nav className="admin-footer-column" aria-label={heading}>
    <h4 className="admin-footer-heading">{heading}</h4>
    <div className="admin-footer-links">
      {links.map((link) => (
        <Link key={link.to} to={link.to} className="admin-footer-link">
          {link.label}
        </Link>
      ))}
    </div>
  </nav>
);

export default AdminFooter;